module.exports = __webpack_public_path__ + "img/error-dark.330d2d2c.svg";